import { formatPrice } from "@jti/format-price";

type finalPricesType = { value: number; currency: string; multiplier: number }[];

export const getFormattedPriceForQuantity = (finalPrices: finalPricesType, quantity: number) => {
  const finalPrice = finalPrices.find((finalPrice) => finalPrice.multiplier === quantity);
  if (!finalPrice?.currency || !finalPrice?.value) return undefined;
  const price = {
    currency: finalPrice.currency,
    value: finalPrice.value,
  };
  return formatPrice(price);
};
